<template>
  <div v-if="submitted" class="container block-bg-white faded">
    <div class="row">
      <div class="col-12 thank-you">
        <h3>Thanks!</h3>
        <p>I'll get back to you as soon as I get your message</p>
      </div>
    </div>
  </div>
  <div v-else class="container block-bg-white faded">
    <div class="row">
      <div class="col-12">
        <h3>Get In touch</h3>
      </div>
      <div class="col-12 col-md-6">
        <div class="wrap">
          <input
            :class="{ 'has-error': v$.name.$errors.length }"
            @focus="v$.name.$reset()"
            type="text"
            v-model="name"
            placeholder="Your name"
          />
          <small v-if="v$.name.$errors.length" class="error-message">
            {{ messageFor(v$.name.$errors[0]) }}
          </small>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="wrap">
          <input
            :class="{ 'has-error': v$.email.$errors.length }"
            @focus="v$.email.$reset()"
            type="email"
            v-model="email"
            placeholder="Your email"
          />
          <small v-if="v$.email.$errors.length" class="error-message">
            {{ messageFor(v$.email.$errors[0]) }}
          </small>
        </div>
      </div>
      <div class="col-12">
        <div class="wrap">
          <input
            :class="{ 'has-error': v$.subject.$errors.length }"
            @focus="v$.subject.$reset()"
            type="text"
            v-model="subject"
            placeholder="What are you like to discuss"
          />
          <small v-if="v$.subject.$errors.length" class="error-message">
            {{ messageFor(v$.subject.$errors[0]) }}
          </small>
        </div>
      </div>
      <div class="col-12">
        <div class="wrap">
          <textarea
            :class="{ 'has-error': v$.message.$errors.length }"
            @focus="v$.message.$reset()"
            v-model="message"
            rows="4"
            placeholder="Your message..."
          />
          <small v-if="v$.message.$errors.length" class="error-message">
            {{ messageFor(v$.message.$errors[0]) }}
          </small>
        </div>
      </div>
      <div class="col-12">
        <div class="wrap">
          <button class="no-ui" @click="handleSubmit">Send Message</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      submitted: false
    };
  },
  validations() {
    return {
      name: {
        required
      },
      email: {
        email,
        required
      },
      subject: {
        required
      },
      message: {
        required
      }
    };
  },
  methods: {
    async handleSubmit() {
      this.v$.$touch();
      if (this.v$.$error) return;

      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: this.encode({
          "form-name": "get-in-touch",
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        })
      });
      this.submitted = true;
    },
    encode(data) {
      return Object.keys(data)
        .map(
          key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");
    },
    messageFor(error) {
      if (error.$validator === "required") {
        return `Please enter your ${error.$property}`;
      } else if (error.$validator === "email") {
        return `This is not a valid email address`;
      } else {
        return error.$message;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./get-in-touch";
</style>
